import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentEvaluationsAndAttempts = async (enrollmentId) => {
  const res = await axios.apiCadernoVirtual(
    "/diary-service/diary/listSurveyAttempts",
    {
      params: { enrollmentId },
    }
  );
  return res.object;
};

export const useStudentEvaluationsAndAttempts = ({
  config,
  enrollmentId,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentsEvaluationsAndAttempts", { enrollmentId }],
    queryFn: () => getStudentEvaluationsAndAttempts(enrollmentId),
  });
};
